import { render, staticRenderFns } from "./CreateABTestModal.vue?vue&type=template&id=03f70dc7&scoped=true"
import script from "./CreateABTestModal.vue?vue&type=script&lang=js"
export * from "./CreateABTestModal.vue?vue&type=script&lang=js"
import style0 from "./CreateABTestModal.vue?vue&type=style&index=0&id=03f70dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f70dc7",
  null
  
)

export default component.exports